import { default as _Icon } from "./icon";
import { default as _IconGroup } from "./icon-group";
var Icon = _Icon;
Icon.Group = _IconGroup;
export default Icon;
//# sourceMappingURL=index.js.map